angular.module('rjmNg.directives').directive "helpContext", [
  () ->
    restrict: "E"
    templateUrl: "directive.helpContext.html"
    replace: false
    scope: 
      context: "@?"
    controllerAs: "view"
    bindToController: true
    controller: [
      "$rootScope"
      "HELP_CONTEXT"
      (
        $rootScope
        HELP_CONTEXT
      ) ->
        view = @
        view.$postLink = () ->
          if view.context?
            view.helpSections = HELP_CONTEXT[view.context]
          else
            $rootScope.$on "updateHelpContext", (event, context) ->
              view.helpSections = HELP_CONTEXT[context]
        view
    ]
]
